<ng-template>
   <div lcsSingleSelectPanel [visible]="true">
      @if (filteredOptions && filteredOptions.length) { @for (option of filteredOptions; track trackBy(option)) {
      <lcs-option [value]="option" [id]="'lcs-option-id-' + trackBy(option)">
         {{ displayWith(option) }}
      </lcs-option>
      } } @else {
      <ng-template [ngTemplateOutlet]="noOptions"></ng-template>
      }
   </div>
</ng-template>
